import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Zap, X } from "lucide-react";

const timeAgo = (iso) => {
  if (!iso) return "";
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 3600) return "just now";
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
};

const line = (j) => {
  const who = j.country ? `${j.name} from ${j.country}` : j.name;
  if (j.role === "seller" && j.founder) return `${who} just became a founding seller`;
  if (j.role === "seller") return `${who} just joined as a seller`;
  return `${who} just joined VISMARKS`;
};

export const SocialProofStrip = () => {
  const [joins, setJoins] = useState([]);
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("vsk_sp_dismissed") === "1");

  useEffect(() => {
    api.get("/social-proof/recent").then(({ data }) => setJoins(data.joins || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (joins.length < 2) return;
    const t = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % joins.length);
        setVisible(true);
      }, 400);
    }, 7000);
    return () => clearInterval(t);
  }, [joins]);

  if (dismissed || joins.length === 0) return null;
  const j = joins[idx];
  const onFeed = window.location.pathname === "/";

  return (
    <div
      data-testid="social-proof-strip"
      className={`fixed bottom-4 left-4 z-40 max-w-[320px] rounded-xl border border-[#27272A] bg-[#121212]/95 backdrop-blur px-4 py-3 shadow-2xl items-start gap-3 ${onFeed ? "hidden lg:flex" : "flex"}`}
      style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(6px)", transitionProperty: "opacity, transform", transitionDuration: "400ms" }}
    >
      <span className="mt-0.5 inline-flex items-center justify-center h-7 w-7 rounded-md bg-[#FF3B30]/15 border border-[#FF3B30]/30 flex-shrink-0">
        <Zap className="h-3.5 w-3.5 text-[#FF3B30]" strokeWidth={2.5} />
      </span>
      <div className="min-w-0">
        <div className="text-sm font-semibold leading-snug" data-testid="social-proof-text">{line(j)}</div>
        <div className="text-[11px] text-neutral-500 mt-0.5">{timeAgo(j.at)} · VISMARKS</div>
      </div>
      <button
        data-testid="social-proof-dismiss"
        aria-label="Dismiss"
        onClick={() => { sessionStorage.setItem("vsk_sp_dismissed", "1"); setDismissed(true); }}
        className="text-neutral-500 hover:text-white ml-1"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
